import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavigationTile from 'components/shared/NavigationTile';

import { formatDateModified } from 'utils/format_date';

import type { Project } from 'domains/projects';

type ProjectActionTileProps = {
  project: Project;
  appearance: 'dark' | 'light';
  onRestore: (project: Project) => void;
  onDelete: (project: Project) => void;
};

function ProjectActionTile(props: ProjectActionTileProps) {
  const { project, appearance, onRestore, onDelete } = props;

  return (
    <NavigationTile
      item={project}
      details={project.description}
      secondaryDetails={`Last edited: ${formatDateModified(project.updated_at)}`}
      name={`${project.name} | ${project.count} item${project.count === 1 ? '' : 's'}`}
      image={project.thumbnail_url}
      clickHandler={() => onRestore(project)}
      menuAppearance={appearance}
      menuItems={[
        {
          icon: <FontAwesomeIcon icon="redo" />,
          label: 'Restore',
          a11yLabel: `Restore project ${project.name}`,
          click: (e) => onRestore(project),
        },
        {
          icon: <FontAwesomeIcon icon="trash-alt" />,
          label: 'Delete',
          a11yLabel: `Delete project ${project.name}`,
          click: (e) => onDelete(project),
        },
      ]}
    />
  );
}

export default ProjectActionTile;
